var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@lucidlink/uicore';
import { Onboarding } from './components';
import { useCheckOnboarding } from './useCheckOnboarding';
export const WorkspaceOnboarding = () => {
    _react_refresh_temp_2();
    const { filespacesData, hasMembers, hasOnboardingPrivileges, isAuthenticated, isError, isPending, workspaceData, } = useCheckOnboarding();
    if (isAuthenticated &&
        hasOnboardingPrivileges &&
        !workspaceData.isSuspended &&
        !workspaceData.isOnboardingCompleted &&
        !isError &&
        !isPending) {
        return (_jsx(Box, { justify: "center", padding: "m", children: _jsx(Onboarding, { filespacesData: filespacesData, hasMembers: hasMembers, workspaceData: workspaceData }) }));
    }
    else {
        return null;
    }
};
_react_refresh_temp_1 = WorkspaceOnboarding;
$RefreshReg$(_react_refresh_temp_1, "WorkspaceOnboarding");
_react_refresh_temp_2(WorkspaceOnboarding, "d/eeLY52VrqqEjXP+fzWE4TXg8M=", false, () => [useCheckOnboarding]);
